import Uploader from '@/packages/vue-media-upload'

export default Uploader
